import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from './content/logo.png';


class Header extends Component {
    render() {
        return (
            <header className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <nav>
                <ul><li><div className="App-title"><Link to={process.env.PUBLIC_URL + "/"}>SmashCV</Link></div></li></ul>
                <ul>
                  {/*<li className="nav-item"><a><p>PGR (Soon&trade;)</p></a></li>*/}
                  {/*<li><a href="/players"><p className="nav-minor">Player View</p></a></li>*/}
                  {/*<li><a href="/characters"><p className="nav-minor">Character Data</p></a></li>*/}
                  <li className="nav-item"><Link to={process.env.PUBLIC_URL + "/players"}><p>Miis</p></Link></li>                  
                  <li className="nav-item"><Link to={process.env.PUBLIC_URL + "/stats"}><p>For Glory</p></Link></li>
                  <li className="nav-item"><Link to={process.env.PUBLIC_URL + "/fstats"}><p>Fighter Stats</p></Link></li>
                </ul>
              </nav>
            </header>
        );
    }
}

export default Header;
